import React from 'react';
import { Link } from "react-router-dom";

const PortfolioItem = ({ portfolio }) => {
    if (!portfolio || !portfolio.id) {
        return null;
    }

    const imageSrc = portfolio.portfolioImage || portfolio.largeImage || '';
    const portfolioSlug = portfolio.slug || portfolio.subtitle || portfolio.id;
    const portfolioUrl = process.env.PUBLIC_URL + `/portfolio-details/${encodeURIComponent(portfolioSlug)}`;

    // Best alt text in this order:
    const altText = 
        portfolio.largeImageAlt?.trim() ||           // Custom alt (highest priority)
        portfolio.portfolioImageAlt?.trim() || 
        portfolio.title?.trim() || 
        "Portfolio project";

    return (
        <div className="rwt-card">
            <div className="inner">
                <div className="thumbnail">
                    <figure className="card-image">
                        <Link to={portfolioUrl}>
                            {imageSrc ? (
                                <img
                                    className="img-fluid"
                                    src={imageSrc}
                                    alt={altText}
                                    loading="lazy" // Bonus: improves performance
                                />
                            ) : (
                                <div style={{
                                    width: '100%',
                                    height: 260,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: '#f8f9fa',
                                    color: '#6c757d',
                                    borderRadius: 12,
                                    border: '2px dashed #dee2e6',
                                    fontSize: '14px'
                                }}>
                                    No image available
                                </div>
                            )}
                        </Link>
                    </figure>
                    <Link to={portfolioUrl} className="rwt-overlay" aria-label={`View ${altText}`} />
                </div>

                <div className="content">
                    <h5 className="title mb--10">
                        <Link to={portfolioUrl}>
                            {portfolio.title || 'Untitled Project'}
                        </Link>
                    </h5>
                    <span className="subtitle b2 text-capitalize">
                        {portfolio.category || 'Uncategorized'}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default PortfolioItem;